import { Box, InputBase, List, useTheme,ToggleButton, ToggleButtonGroup } from "@mui/material"
import { useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import AddIcon from '@mui/icons-material/Add';
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import NumberInput from "../../theme/inputs/NumberInput";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify"; 
import { useAddWarehouseZoneMutation } from "../../../newapi/warehouse/warehouseApiSlice";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../utils/toasts";
import ShSwitch from "../../theme/inputs/ShSwitch";
import * as yup from "yup";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import { yupRequired } from "../../../utils/validation";

const MAddWarehouseZone = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [selected, setSelected] = useState(-1);
    const [addWarehouseZone,{isLoading}] = useAddWarehouseZoneMutation();

    const select = (selected) => {
        setSelected(selected);
    }

    const [warehouseZoneInfo, setWarehouseZoneInfo] = useState({
        description: "",
        multiproduct: false,
        multibatch: false,
        warehouseId: props.warehouseId
    });

    const [fieldErrors, setFieldErrors] = useState({});

    const rules = {
        description: yupRequired('description', t)
        };
        
        const schema = yup.object().shape(rules);
      
   
    const SaveWarehouseZone = async (warehouseZoneInfo, props) => {
        try {
            if (isLoading) return;

            setFieldErrors({});
            await schema.validate(warehouseZoneInfo, { abortEarly: false });
            
            const data = await addWarehouseZone(warehouseZoneInfo).unwrap()
            showToastMessagePostRequest(t, data);

            // reset object
            setWarehouseZoneInfo({
                description: "",
                multiproduct: false,
                multibatch: false,
                warehouseId: props.warehouseId
            });

            props.handleClose();
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                  ...acc,
                  [currentError.path]: currentError.message
                }), {});
          
                // Set the validation errors in the state
                setFieldErrors(errors);
              } else {
                // Handle other errors, such as network errors
                showToastMessageRequestError(t("create_failed"), t, err);
              }
        }
    };
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleChange = (key, value) => {
        setWarehouseZoneInfo({
          ...warehouseZoneInfo,
          [key]: value
        });
        setFieldErrors({
            ...fieldErrors,
            [key]: ''
          });
      };
      

    return(
        <SHModal
            open={props.open}
            onClose={props.handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("add_zone")}</Subheading>
                {/* <Text light>The data presented will automatically be filtered through the selected warehouses</Text> */}
            </Box>

            {/* BODY */}
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                

                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:144,
                        }}
                    >
                        <Text light>{t("description")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ShValidatedInput
                            name="description"
                            value={warehouseZoneInfo.description}
                            onChange={handleChange}
                            error={fieldErrors.description}
                        />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:144,
                        }}
                    >
                        <Text light>{t("multibatch")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ShSwitch 
                            sx={{
                                px:2,
                                // flex:1, 
                                color:colors.txt["primary"],
                                lineHeight:"32px",
                            }}
                            checked={warehouseZoneInfo.multibatch} 
                            onChange={(event) => handleChange('multibatch', event.target.checked)}
                            color="green" />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:144,
                        }}
                    >
                        <Text light>{t("multiproduct")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ShSwitch 
                            sx={{
                                px:2,
                                // flex:1, 
                                color:colors.txt["primary"],
                                lineHeight:"32px",
                            }}
                            checked={warehouseZoneInfo.multiproduct} 
                            onChange={(event) => handleChange('multiproduct', event.target.checked)}
                            color="green" />
                    </Box>
                </Box>
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton isLoading={isLoading} className={"group-btn"} color={"green"}
                    variant="contained" 
                    onClick={() => SaveWarehouseZone(warehouseZoneInfo, props)}
                    >{t("add")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MAddWarehouseZone;
